import { XMarkIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import Tooltip from 'components/layout/tooltip';
import { MouseEvent } from 'react';

type XButtonProps = {
  onClick?: (
    event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => void;
  onDisabledClick?: (
    event?: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => void;
  disabled?: boolean;
  size?: 'sm' | 'md';
  color?: 'red' | 'gray';
  tooltip?: string;
  ariaLabel?: string;
};

export default function XButton({
  onClick,
  onDisabledClick,
  disabled,
  size = 'sm',
  color = 'red',
  tooltip,
  ariaLabel
}: XButtonProps) {
  const classes = clsx(
    'rounded-full flex items-center justify-center relative',
    disabled && 'opacity-[70%] cursor-not-allowed',
    size === 'sm' ? 'h-5 w-5' : 'h-6 w-6',
    color === 'red' && 'bg-red-500 hover:bg-red-600 text-white',
    color === 'gray' && 'bg-gray-300 hover:bg-gray-400 text-black'
  );

  const iconClasses = size === 'sm' ? 'h-4 w-4' : 'h-5 w-5';

  const handleClick = (
    event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => {
    if (onClick && !disabled) {
      onClick(event);
    }
    if (onDisabledClick && disabled) {
      onDisabledClick(event);
    }
  };

  return (
    <button
      type='button'
      className={classes}
      aria-label={ariaLabel}
      onClick={(e) => handleClick(e)}
    >
      {tooltip && <Tooltip text={tooltip} />}
      <XMarkIcon className={iconClasses} />
    </button>
  );
}
